import { CircularProgress } from "@chr/eds-react";
import { ButtonProps } from "@chr/eds-react/Button/ButtonProps";
import { Button, Icon } from "@mui/material";

type InternalProgressButtonProps = {
  showProgress: boolean;
}

export type ProgressButtonProps = InternalProgressButtonProps & ButtonProps;

export const ProgressButton = ({
  showProgress,
  ...buttonProps
}: ProgressButtonProps) => {

  const getIconBaseClassName = (iconVariant: string | undefined) => {
    const muiPrefix = 'material-icons';
    switch (iconVariant) {
      case 'twoToned':
        return `${muiPrefix}-two-tone`;
      case 'filled':
        return `${muiPrefix}`;
      case 'rounded':
        return `${muiPrefix}-round`;
      case 'sharp':
        return `${muiPrefix}-sharp`;
      case 'outlined':
      default:
        return `${muiPrefix}-outlined`;
    }
  };

  const getStartIcon = () => {
    if (showProgress){
      return (
        <CircularProgress
          size='md' // Only 'md' size works
          aria-label='Send Progress Icon'
        />
      )
    } else {
      if (buttonProps.startIcon){
        return (
          <Icon
            aria-label={buttonProps.startIcon}
            baseClassName={getIconBaseClassName(buttonProps.iconVariant)}
          >
            {buttonProps.startIcon}
          </Icon>
        );
      }
    }
  }

  return (
    // Copied from eds-react source code and added showProgress logic
    <Button
      id={buttonProps.id}
      variant={buttonProps.variant}
      disabled={buttonProps.disabled}
      onClick={buttonProps.onClick}
      size='large'
      fullWidth={buttonProps.fullWidth ? buttonProps.fullWidth : false}
      disableRipple
      disableElevation

      startIcon={getStartIcon()}
      sx={[
        // Disable button when showProgress
        showProgress && {
          pointerEvents: 'none',
          cursor: 'default',
        }
      ]}
    >
      {buttonProps.buttonText}
    </Button>
  )
}
